import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-all-offers',
  templateUrl: './all-offers.component.html',
  styleUrls: ['./all-offers.component.scss']
})
export class AllOffersComponent {}
